import React from "react";
import { ResponsiveContainer, BarChart, XAxis, YAxis, Bar } from "recharts";

function formatNumber(val, precision) {
  return val.toFixed(precision);
}

function CustomLabel({
  x,
  y,
  width,
  height,
  value,
  prefix,
  suffix,
  precision,
  layout = "horizontal",
  xOffset = 30,
  yOffset = 10,
  hideZero = false,
  tooltipContent = ""
}) {
  const xxOffset =
    layout === "horizontal"
      ? x + width / 2
      : value < 0
      ? x + width - xOffset
      : x + width + xOffset;
  const yyOffset =
    layout === "vertical"
      ? y + height / 2
      : value < 0
      ? y + yOffset
      : y - yOffset;
  const className = value < 0 ? "red" : null;
  const val =
    hideZero === true && value === 0
      ? "n/a"
      : `${prefix}${formatNumber(value, precision)}${suffix}`;

  return (
    <text
      x={xxOffset}
      y={yyOffset}
      className={className}
      textAnchor="middle"
      dominantBaseline="middle"
    >
      {tooltipContent !== "" ? tooltipContent : val}
    </text>
  );
}

const DashboardBarChart = ({
  height,
  color,
  value,
  labelOffset = 20,
  labelYOffset = 10,
  rightMargin = 45,
  animation = true,
  labelSuffix = "",
  tooltipContent = ""
}) => (
  <ResponsiveContainer width="100%" height={height}>
    <BarChart
      data={[{ value }]}
      layout="vertical"
      margin={{ top: 0, left: 0, right: rightMargin, bottom: 0 }}
    >
      <XAxis type="number" hide={true} domain={[0, 100]} />
      <YAxis type="category" hide={true} />
      <Bar
        isAnimationActive={animation}
        dataKey="value"
        fill={color}
        minPointSize={5}
        label={
          <CustomLabel
            prefix=""
            precision={0}
            suffix={labelSuffix}
            xOffset={labelOffset}
            yOffset={labelYOffset}
            layout="vertical"
            tooltipContent={tooltipContent}
          />
        }
      />
    </BarChart>
  </ResponsiveContainer>
);

export default DashboardBarChart;



// WEBPACK FOOTER //
// ./src/instructor/components/dashboard-bar-chart.js